// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://phlrekrgfwqyiktbhlyn.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InBobHJla3JnZndxeWlrdGJobHluIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTk5MjUzNjgsImV4cCI6MjA3NTUwMTM2OH0.6IJZWBKRuwQg3FeY6PJueeoeSC_3OFcUVbInUUz3Av4";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});